import React from 'react';

function FormExtended(props){
  return (
    <div className="row"> 
      <div className="col-12"></div>  
    </div>      
  )
}
export default FormExtended